export const LANDING = "/";
export const SIGN_UP = "/signup";
export const SIGN_IN = "/login";
export const SIGN_OUT = "/signout";
export const HOME = "/home";
export const ACCOUNT = "/manage-account";
export const PASSWORD_FORGET = "/pw-forget";
export const TERMS_OF_USE = "/terms-of-use";
export const MY_FILES = "/my-files";
export const HISTORY = "/history";
export const COLLECTIONS = "/collections";
export const FEEDBACK = "/feedback";
export const THANKYOU = "/thankyou";
export const CONVERTER = "/converter";
export const DOCUMENTATION = "/documentation";
export const NOTIFICATIONS = "/notifications";
export const TERMS_AND_CONDITIONS = "/TermsAndConditions";
